import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectCardinalPlural } from '~/utils/Intl';
import { Action } from '~/Product/Action';
import { showAllProductsAction } from '~/Product/actions';
import { State, ThunkDispatch } from '~/Store';
import Checkbox from '~/UI/Checkbox/Checkbox';
import Icon from '~/UI/Icon';
import { TailwindTooltip } from '../TailwindTooltip';

export interface Props {
	alternativeProductsCount: number;
}

export function ProductGroupShowAllItemsSwitch({ alternativeProductsCount }: Props) {
	const showAllProducts = useSelector<State, boolean>((state) => state.products.showAllProducts);
	const dispatch: ThunkDispatch<Action> = useDispatch();
	const update = useCallback((showAllProducts: boolean) => {
		dispatch(showAllProductsAction(!showAllProducts));
	}, []);

	if (alternativeProductsCount === 0) {
		return null;
	}

	return (
		<>
			<Checkbox checked={!showAllProducts} onChange={update}>
				Hide {alternativeProductsCount} {selectCardinalPlural(alternativeProductsCount, ['product', 'products'])}{' '}
				excluded from calculation of max price
			</Checkbox>
			<TailwindTooltip
				reference={<Icon name='violet-question-mark' />}
				displayClass='inline-block ml-2'
				position='left'
			>
				<p className='leading-snug'>
					Products are excluded from the calculation by unchecking the <strong>Use for calc.</strong> field, either
					manually or automatically (based on the product details).
				</p>
				<p className='leading-snug'>
					By default, all products from alternative data sources, products not present in current datasets, products
					without price and products with expired validity are automatically unchecked and hidden upon inserting of
					products into the product list
				</p>
			</TailwindTooltip>
		</>
	);
}
